module.exports = __webpack_public_path__ + "img/team-logo.e4ca45da.png";